<div class="padding-20 ui-g" id="c3_searchPaniere_Modal">

  <!-- Bottoni Annulla e Aggiungi -->

  <div class="ui-dialog-footer buttonsContainer fixed-buttons">
    <button pButton (click)="onClickAnnullaPaniere()" data-testid="basketCancelButton" type="button" class="k-generic-btn footer-btn"
      label="{{'common.cancel' | translate}}"></button>
    <button pButton type="button" (click)="onClickAggiungiPaniere()" data-testid="basketAddButton" type="button" class="k-generic-btn footer-btn"
      label="{{'common.add' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

  <br />
  <br />
  <br />


  <div class="ui-g-12">
    <div class="ui-g-6">
      <div class="c3_actionTypeContainer">
        <div data-testid="listBaskets" class="c3_actionType" [ngStyle]="{'width': '50%' }" [ngClass]="{'actionTypeActive': choiceCode == 'LIST' }"
        (click)="onClickElenco()">{{ 'campaign.basketList' | translate }}</div>
  <div data-testid="newBasket" class="c3_actionType" [ngStyle]="{'width': '50%' }" [ngClass]="{'actionTypeActive': choiceCode == 'NEW' }"
        (click)="onClickNuovo()">{{ 'campaign.newBasket' | translate }}</div>

        <div class="clear_fix"></div>
      </div>
    </div>

  </div>

  <div class="ui-g" *ngIf="choiceCode == 'LIST'">
    <app-campaign-3-kontable *ngIf="paniereList && show.tableBasket" id="paniereList" [columns]="[
      { field: 'basketName', title: 'campaign.basketName' },
      { field: 'basketDescription', title: 'campaign.description' },
      { field: 'articoli', title: 'campaign.articles' }
  ]" [paginationType]="paginationType" [showInfoButton]="false" [showGlobalFilter]="false" [showDetailsButton]="false"
      [showRecoverButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false"
      [showDeleteButton]="false" [allowSelectRow]="false" [source]="paniereList" [showSelectButton]="true"
      (onSelected)="onPaniereSelected($event)" #paniereListTable>


    </app-campaign-3-kontable>

  </div>



  <div class="ui-g" *ngIf="choiceCode == 'NEW'">

    <div class="ui-g-12">
    <div class="ui-g-8 ui-g">


      <div class="ui-g-3">
        <label for="new_name_paniere">{{ 'campaign.basketName' | translate }}</label><span class="asterix">*</span>
        <app-form-fields #new_name_paniere data-testid="new_name_paniere" [(fieldModel)]="fieldModel.new_name_paniere"
          [name]="'new_name_paniere'" [required]="true" [label]="''" [type]="'string'" [maxLength]="200"></app-form-fields>
    </div>

    <div class="ui-g-6">
        <label for="new_description_paniere">{{ 'campaign.description' | translate }}</label><span class="asterix">*</span>
        <app-form-fields #new_description_paniere data-testid="new_description_paniere"
          [(fieldModel)]="fieldModel.new_description_paniere" [name]="'new_description_paniere'" [required]="true"
          [label]="''" [type]="'string'" [maxLength]="200"></app-form-fields>
    </div>

    <div class="ui-g-3" >
        <label for="new_code_paniere">{{ 'campaign.code' | translate }}</label><span class="asterix">*</span>
        <app-form-fields #new_code_paniere data-testid="new_code_paniere" [(fieldModel)]="fieldModel.new_code_paniere"
          [name]="'new_code_paniere'" [required]="true" [label]="''" [type]="'string'" [maxLength]="200"></app-form-fields>
    </div>



    </div>

    <div class="ui-g-4 ui-g" style="margin-top: 20px">
      <div class="ui-g-6">
        <span class="switchTitle" id="switchSeleziona">
          <p-inputSwitch [(ngModel)]="switch.seleziona" (onChange)="onChangeSwitchSeleziona()"></p-inputSwitch>
          <span class="labelSwitch">{{ 'campaign.selectArticles' | translate }}</span>
        </span>
      </div>
      <div class="ui-g-6">
      <!--   <span class="switchTitle" id="switchImporta">
          <p-inputSwitch [(ngModel)]="switch.importa" (onChange)="onChangeSwitchImporta()"></p-inputSwitch>
          <span class="labelSwitch">{{ 'campaign.importFromCSV' | translate }}</span>
        </span> -->
      </div>
    </div>


    </div>


    <div class="ui-g-12" *ngIf="switch.seleziona == true">


      <!-- KS-7308 -->
      <app-campaign-3-kontable *ngIf="show.tableProduct" id="productsListPaniereTable" [columns]="[
      { field: 'code', title: 'campaign.code' },
      { field: 'description', title: 'campaign.description' },
      { field: 'product_categories', title: 'campaign.category' },
      { field: 'product_department', title: 'campaign.department' },
      { field: 'barcode', title: 'campaign.barcode' }
    ]"
     [paginationType]="paginationType"  [service]="srvCampaign3"
        [rowSelected]="rowSelected"
        [methodsNames]="{ list: 'getProductItemComplete', sendExtSearchQuery: 'sendExtSearchQuery' }"
        [showInfoButton]="false" [showGlobalFilter]="false" [showDetailsButton]="false" [showRecoverButton]="false"
        [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false" [showDeleteButton]="false"
        [allowSelectRow]="false" [showSelectButton]="true" (onSelected)="onProductsSelected($event)"
        [filterBySingleColumn]="false"
        #productsListPaniereTable>



      </app-campaign-3-kontable>

    </div>


   <!--  <div class="ui-g-12" *ngIf="switch.importa == true">
      <div>WORK IN PROGRESS...</div>
    </div> -->
  </div>




</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-paniere/campaign-3-search-paniere.component.html